export class CodeNameObj {
    code: string;
    name: string;
}
